export const environment = {
    orgId: 'mayannew',
    production: true,
    apiURL: "https://www.mayanhandicrafts.in"
}